import { createFileRoute, redirect } from "@tanstack/react-router";

import { boilerRoomApi } from "~/api";
import { getFirstSelectableBoilerRoom } from "~/features/boiler-room/helpers";
import { requirePagePermission } from "~/helpers/auth/route-permission.helper";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/boiler-rooms/")({
  beforeLoad: ({ context: { permissions }, params: { buildingId }, preload }) => {
    requirePagePermission(permissions, "boilerroom", buildingId, preload);
  },
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    const boilerRooms = await queryClient.ensureQueryData(boilerRoomApi.queries.building(buildingId));
    // Only full boiler rooms carry `parentId`, needed to skip substations.
    const fullBoilerRooms = await Promise.all(
      boilerRooms.map(boilerRoom => queryClient.ensureQueryData(boilerRoomApi.queries.boilerRoom(boilerRoom.id))),
    );
    const first = getFirstSelectableBoilerRoom(fullBoilerRooms);
    if (!first) throw redirect({ to: "/buildings/$buildingId/dashboard", params: { buildingId }, replace: true });
    throw redirect({
      to: "/buildings/$buildingId/boiler-rooms/$boilerRoomId",
      params: { buildingId, boilerRoomId: first.id },
      replace: true,
    });
  },
  component: () => null,
});
